import React, { useState } from 'react';
import './XR.css';
import Navbar from '../components/Navbar';

const Monitoring = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <div className="xr-content">
          <p className="page-path">Services / Spatial Monitoring & Management Systems</p>
          <h5 className="xr-title">Spatial Monitoring & Management Systems</h5>
          <p className="subtitle">Bring environments to life with interactive spatial experiences</p>
          <p>
            Deploy spatially intelligent dashboards and control rooms that deliver real-time situational awareness and data-driven insights. These immersive solutions enhance monitoring and decision-making in critical environments.
            <span className="know-toggle" onClick={() => setShowMore(!showMore)}>
              {showMore ? ' Know less' : ' Know more...'}
            </span>
          </p>
          
          {/* {showMore && (
            <p className="extra-text">
              These systems integrate 3D spatial data with live sensor feeds and contextual alerts to provide actionable intelligence for efficient facility management and operational control.
            </p>
          )} */}

          <div className="xr-highlights">
            <h6>Highlights:</h6>
            <ul>
              <li>Real-time monitoring with 3D environments and live data overlays</li>
              <li>Context-aware alerts and actionable analytics.</li>
              <li>Applications in factory operations, smart campuses, and infrastructure management</li>
            </ul>
          </div>
        </div>
        <div className="xr-image-wrapper">
          <img src="../images/page1image10.webp" alt="XR Workshop" className="xr-image" />
        </div>
      </div>
    </>
  );
};

export default Monitoring;
